import { createContext } from 'react';
/**
 * When true, ToolTip switches to viewport-positioned (`position: fixed` with
 * `getBoundingClientRect`-based offsets) AND portals itself to document.body.
 *
 * Use this anywhere a tooltip would otherwise be cropped by an ancestor with
 * `overflow: auto/hidden/clip` (e.g. a scrollable drawer). Wrap the affected
 * subtree:
 *
 *   <TooltipPortalContext.Provider value={true}>
 *     <ScrollableContainer>...</ScrollableContainer>
 *   </TooltipPortalContext.Provider>
 *
 * Default is `false` so existing in-place tooltips render as before.
 */
export var TooltipPortalContext = createContext(false);
